import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full bg-white py-20 px-4 md:px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-3">
          {/* For Whom */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-teal-light/30 p-8 rounded-2xl border border-teal/10" data-id="element-4">
            <h3 className="text-2xl font-bold text-teal-dark mb-6 flex items-center gap-2" data-id="element-5">
              <CheckCircle2 className="text-teal" data-id="element-6" /> Para quién es
            </h3>
            <ul className="space-y-4" data-id="element-7">
              {['Mujeres 35+ (peri/meno o “algo cambió”)', 'Ocupadas, con vida real', 'Harta de empezar de cero', 'Quiere estructura, no castigo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-warm-dark" data-id="element-8">
                  <CheckCircle2 size={18} className="text-teal mt-1 shrink-0" data-id="element-9" />
                  <span data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Whom */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-warm-gray/5 p-8 rounded-2xl border border-warm-gray/10" data-id="element-11">
            <h3 className="text-2xl font-bold text-warm-gray mb-6 flex items-center gap-2" data-id="element-12">
              <XCircle className="text-warm-gray" data-id="element-13" /> Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-14">
              {['Si buscas “pierde X kilos en 7 días”', 'Si quieres un plan extremo', 'Si no estás dispuesta a priorizar sueño/estrés aunque sea con mínimos'].map((item, i) => <li key={i} className="flex items-start gap-3 text-warm-gray" data-id="element-15">
                  <XCircle size={18} className="text-warm-gray mt-1 shrink-0" data-id="element-16" />
                  <span data-id="element-17">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}